import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as LogoFull } from "../../assets/images/instadrops-logo.svg";

import { ReactComponent as LogoDark } from "../../assets/images/instadrop-logo-dark.svg";

import { ReactComponent as LogoLight } from "../../assets/images/instadrop-logo-white.svg";

const Logo = ({ variant = "full", size = "medium", color = "primary" }) => {
  const sizeStyle = (size) => {
    switch (size) {
      case "extra-small":
        return "30px";
      case "small":
        return "40px";
      case "medium":
        return "100px";
      case "large":
        return "90px";
    }
  };
  const colorStyle = color === "white" ? "#fff" : "#3CBA68";

  switch (variant) {
    case "light": {
      return (
        <LogoLight
          style={{
            height: sizeStyle(size),
          }}
        />
      );
    }
    case "dark": {
      return (
        <LogoDark
          style={{
            height: sizeStyle(size),
          }}
        />
      );
    }
    default: {
      return <LogoFull fill={colorStyle} style={{ marginTop: 11 }} />;
    }
  }
};

Logo.propTypes = {
  variant: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
};

export { Logo };
export default Logo;
